'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var UserFareExclusionRulesService = function UserFareExclusionRulesService(fileSaveService, momentService, restangular, $q, $http) {
  var updateBulkExclusionRulesService = restangular.service('external').one('faresoptimizer').one('fareexclusionrules').one('bulk');
  function formatAsCsvRow(stringArayToFormat) {
    return stringArayToFormat.join(',') + '\r\n';
  }
  function createCsvHeader() {
    return formatAsCsvRow(['Carrier', 'Cabin', 'Category', 'RBD', 'FBC', 'Origin City', 'Destination City', 'Origin Country', 'Destination Country', 'Travel From Date', 'Travel To Date', 'Travel Start Time', 'Travel End Time', 'Sell Date From', 'Sell Date To', 'OWRT Ind', 'Origin Region', 'Destination Region', 'Footnote', 'Routing Id', 'Effective Date', 'Discontinue Date']);
  }
  function createCsvRow(row) {
    return formatAsCsvRow([row.foCarrier, row.foCabin, row.category, row.foRbd, !_.isNil(row.fareBasisCode) ? row.fareBasisCode.toUpperCase() : undefined, row.origin, row.destination, row.foOriginCountry, row.foDestCountry, row.travelFromDate ? row.travelFromDate.toISOString() : undefined, row.travelToDate ? row.travelToDate.toISOString() : undefined, !_.isNil(row.travelStartTime) ? row.travelStartTime.toString() : undefined, !_.isNil(row.travelEndTime) ? row.travelEndTime.toString() : undefined, row.sellDateFrom ? row.sellDateFrom.toISOString() : undefined, row.sellDateTo ? row.sellDateTo.toISOString() : undefined, row.tripType, row.foOriginRegion, row.foDestRegion, row.footnote, row.routingId, row.effectiveDate ? row.effectiveDate.toISOString() : undefined, row.discontinueDate ? row.discontinueDate.toISOString() : undefined]);
  }
  function exportToCsv(data) {
    var fileData = createCsvHeader();
    for (var rowId = 0; rowId < data.length; rowId++) {
      fileData += createCsvRow(data[rowId]);
    }
    fileSaveService.createFile(fileData, 'text/csv', 'FOFareExclusionRules.csv');
  }
  function deleteFromServer(payloads) {
    return _.map(payloads, function (payload) {
      return $http({
        method: 'DELETE',
        url: '/api/external/faresoptimizer/fareexclusionrules',
        data: payload,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      });
    });
  }
  function remove(rows) {
    var payloads = buildRemovePayloads(rows);
    return $q.all(deleteFromServer(payloads));
  }
  function saveToServer(payloads) {
    return updateBulkExclusionRulesService.customPUT({
      value: payloads
    });
  }
  function validate(editedRows, gridData) {
    var filteredData = _.reject(gridData, {
      'isNewlyAdded': true
    });
    return areRowsValid(editedRows, filteredData);
  }
  function areRowsValid(editedRows, gridData) {
    var valid = true;
    _.forEach(editedRows, function (editedRow) {
      if (_.isNil(editedRow.foCarrier)) {
        toastr.error('Carrier must not be empty');
        valid = false;
        return false;
      }
      var modifiedRow = _.omit(editedRow, ['isNewlyAdded', 'isRowEditable', '_old']);
      _.forEach(gridData, function (row) {
        if (_.isEqual(_.pickBy(row), _.pickBy(modifiedRow))) {
          toastr.error('duplicate rows identified');
          valid = false;
          return false;
        }
      });
      if (!valid) {
        return false;
      }
    });
    return valid;
  }
  function save(editedRows) {
    var rowsForDeletion = [];
    _.forEach(editedRows, function (editedRow) {
      if (_.has(editedRow, '_old') && !_.has(editedRow, 'isNewlyAdded')) {
        rowsForDeletion.push(buildPayLoadForRemovalWhileSaving(editedRow));
      }
    });
    if (!_.isEmpty(rowsForDeletion)) {
      $q.all(deleteFromServer(rowsForDeletion));
    }
    var payloads = buildSavePayloads(editedRows);
    var promises = [];
    if (payloads && payloads.length) {
      promises.push(saveToServer(payloads));
    }
    return $q.all(promises);
  }
  function buildRemovePayloads(rows) {
    return _.reduce(rows, function (result, row) {
      result.push(buildPayLoadForRemoval(row));
      return result;
    }, []);
  }
  function buildPayLoadForRemoval(row) {
    return {
      carrier: getStringValue(row.foCarrier),
      cabin: getStringValue(row.foCabin),
      category: getStringValue(row.category),
      rbd: getStringValue(row.foRbd),
      fareBasisCode: getStringValue(row.fareBasisCode),
      origin: getStringValue(row.origin),
      destination: getStringValue(row.destination),
      originCountry: getStringValue(row.foOriginCountry),
      destinationCountry: getStringValue(row.foDestCountry),
      travelFromDate: row.travelFromDate ? row.travelFromDate.toISOString() : null,
      travelToDate: row.travelToDate ? row.travelToDate.toISOString() : null,
      travelStartTime: row.travelStartTime ? row.travelStartTime.toString() : null,
      travelEndTime: row.travelEndTime ? row.travelEndTime.toString() : null,
      sellDateFrom: row.sellDateFrom ? row.sellDateFrom.toISOString() : null,
      sellDateTo: row.sellDateTo ? row.sellDateTo.toISOString() : null,
      owrtInd: !_.isNil(row.tripType) ? parseInt(row.tripType) : null,
      tacticalFareType: getStringValue(row.tacticalFareType),
      flightPair: getStringValue(row.flightPair),
      originRegion: getStringValue(row.foOriginRegion),
      destinationRegion: getStringValue(row.foDestRegion),
      footnote: getStringValue(row.footnote),
      routingId: !_.isNil(row.routingId) ? parseInt(row.routingId) : null,
      effectiveDate: row.effectiveDate ? row.effectiveDate.toISOString() : null,
      discontinueDate: row.discontinueDate ? row.discontinueDate.toISOString() : null
    };
  }
  function getDateForRemoval(value) {
    return value ? value.toISOString() : null;
  }
  function getTimeForRemoval(value, oldValue) {
    return oldValue ? oldValue.toString() : value ? value.toString() : null;
  }
  function getIntValueForRemoval(value) {
    return !_.isNil(value) ? parseInt(value) : null;
  }
  function getStringValue(value) {
    return _.isNil(value) || _.isEmpty(value) ? null : value;
  }
  function buildPayLoadForRemovalWhileSaving(row) {
    return {
      carrier: getStringValue(row.foCarrier),
      cabin: _.has(row._old, 'foCabin') ? getStringValue(row._old.foCabin) : getStringValue(row.foCabin),
      category: _.has(row._old, 'category') ? getStringValue(row._old.category) : getStringValue(row.category),
      rbd: _.has(row._old, 'foRbd') ? getStringValue(row._old.foRbd) : getStringValue(row.foRbd),
      fareBasisCode: _.has(row._old, 'fareBasisCode') ? getStringValue(row._old.fareBasisCode) : getStringValue(row.fareBasisCode),
      origin: _.has(row._old, 'origin') ? getStringValue(row._old.origin) : getStringValue(row.origin),
      destination: _.has(row._old, 'destination') ? getStringValue(row._old.destination) : getStringValue(row.destination),
      originCountry: _.has(row._old, 'foOriginCountry') ? getStringValue(row._old.foOriginCountry) : getStringValue(row.foOriginCountry),
      destinationCountry: _.has(row._old, 'foDestCountry') ? getStringValue(row._old.foDestCountry) : getStringValue(row.foDestCountry),
      travelFromDate: _.has(row._old, 'travelFromDate') ? getDateForRemoval(row._old.travelFromDate) : getDateForRemoval(row.travelFromDate),
      travelToDate: _.has(row._old, 'travelToDate') ? getDateForRemoval(row._old.travelToDate) : getDateForRemoval(row.travelToDate),
      travelStartTime: _.has(row._old, 'travelStartTime') ? getTimeForRemoval(row._old.travelStartTime) : getTimeForRemoval(row.travelStartTime),
      travelEndTime: _.has(row._old, 'travelEndTime') ? getTimeForRemoval(row._old.travelEndTime) : getTimeForRemoval(row.travelEndTime),
      sellDateFrom: _.has(row._old, 'sellDateFrom') ? getDateForRemoval(row._old.sellDateFrom) : getDateForRemoval(row.sellDateFrom),
      sellDateTo: _.has(row._old, 'sellDateTo') ? getDateForRemoval(row._old.sellDateTo) : getDateForRemoval(row.sellDateTo),
      owrtInd: _.has(row._old, 'tripType') ? getIntValueForRemoval(row._old.tripType) : getIntValueForRemoval(row.tripType),
      tacticalFareType: _.has(row._old, 'tacticalFareType') ? getStringValue(row._old.tacticalFareType) : getStringValue(row.tacticalFareType),
      flightPair: _.has(row._old, 'flightPair') ? getStringValue(row._old.flightPair) : getStringValue(row.flightPair),
      originRegion: _.has(row._old, 'foOriginRegion') ? getStringValue(row._old.foOriginRegion) : getStringValue(row.foOriginRegion),
      destinationRegion: _.has(row._old, 'foDestRegion') ? getStringValue(row._old.foDestRegion) : getStringValue(row.foDestRegion),
      footnote: _.has(row._old, 'footnote') ? getStringValue(row._old.footnote) : getStringValue(row.footnote),
      routingId: _.has(row._old, 'routingId') ? getIntValueForRemoval(row._old.routingId) : getIntValueForRemoval(row.routingId),
      effectiveDate: _.has(row._old, 'effectiveDate') ? getDateForRemoval(row._old.effectiveDate) : getDateForRemoval(row.effectiveDate),
      discontinueDate: _.has(row._old, 'discontinueDate') ? getDateForRemoval(row._old.discontinueDate) : getDateForRemoval(row.discontinueDate)
    };
  }
  function buildPayload(row) {
    return {
      carrier: getStringValue(row.foCarrier),
      cabin: !_.isNil(row.foCabin) ? getStringValue(row.foCabin) : undefined,
      category: !_.isNil(row.category) ? getStringValue(row.category) : undefined,
      rbd: !_.isNil(row.foRbd) ? getStringValue(row.foRbd) : undefined,
      fareBasisCode: !_.isNil(row.fareBasisCode) ? getStringValue(row.fareBasisCode) : undefined,
      origin: !_.isNil(row.origin) ? getStringValue(row.origin) : undefined,
      destination: !_.isNil(row.destination) ? getStringValue(row.destination) : undefined,
      originCountry: !_.isNil(row.foOriginCountry) ? getStringValue(row.foOriginCountry) : undefined,
      destinationCountry: !_.isNil(row.foDestCountry) ? getStringValue(row.foDestCountry) : undefined,
      travelFromDate: row.travelFromDate ? row.travelFromDate.toISOString() : undefined,
      travelToDate: row.travelToDate ? row.travelToDate.toISOString() : undefined,
      travelStartTime: !_.isNil(row.travelStartTime) ? row.travelStartTime.toString() : undefined,
      travelEndTime: !_.isNil(row.travelEndTime) ? row.travelEndTime.toString() : undefined,
      sellDateFrom: row.sellDateFrom ? row.sellDateFrom.toISOString() : undefined,
      sellDateTo: row.sellDateTo ? row.sellDateTo.toISOString() : undefined,
      owrtInd: !_.isNil(row.tripType) ? parseInt(row.tripType) : undefined,
      tacticalFareType: !_.isNil(row.tacticalFareType) ? getStringValue(row.tacticalFareType) : undefined,
      flightPair: !_.isNil(row.flightPair) ? getStringValue(row.flightPair) : undefined,
      originRegion: !_.isNil(row.foOriginRegion) ? getStringValue(row.foOriginRegion) : undefined,
      destinationRegion: !_.isNil(row.foDestRegion) ? getStringValue(row.foDestRegion) : undefined,
      footnote: !_.isNil(row.footnote) ? getStringValue(row.footnote) : undefined,
      routingId: !_.isNil(row.routingId) ? parseInt(row.routingId) : undefined,
      effectiveDate: row.effectiveDate ? row.effectiveDate.toISOString() : undefined,
      discontinueDate: row.discontinueDate ? row.discontinueDate.toISOString() : undefined
    };
  }
  function buildSavePayloads(rows) {
    return _.reduce(rows, function (result, row) {
      result.push(buildPayload(row));
      return result;
    }, []);
  }
  return {
    validate: validate,
    exportToCsv: exportToCsv,
    save: save,
    remove: remove
  };
};
UserFareExclusionRulesService.$inject = ['FileSaveService', 'MomentService', 'Restangular', '$q', '$http'];
module.exports = UserFareExclusionRulesService;